import { render, staticRenderFns } from "./CampHeader.vue?vue&type=template&id=7b363211&lang=pug&"
import script from "./CampHeader.vue?vue&type=script&lang=js&"
export * from "./CampHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports